// src/components/NavBar.tsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode'; // Keep the default import
import 'bootstrap/dist/css/bootstrap.min.css';

interface JwtPayload {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string; // Username claim
}

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('token');
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded: JwtPayload = jwtDecode(token); // Explicitly call jwtDecode as a function
        setUsername(decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']);
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
  }, []);

  const handleAuthAction = () => {
    if (isLoggedIn) {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event('authChange'));
      navigate('/');
    } else {
      navigate('/');
    }
    setIsExpanded(false);
    setActiveDropdown(null);
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    setActiveDropdown(null);
  };

  const handleDropdown = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const handleLinkClick = () => {
    setIsExpanded(false);
    setActiveDropdown(null);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          onClick={handleToggle}
          aria-controls="navbarNav"
          aria-expanded={isExpanded}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${isExpanded ? 'show' : ''}`}
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/dashboard" onClick={handleLinkClick}>
                Dashboard
              </Link>
            </li>
            {/* Forms Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={() => handleDropdown('forms')}
                aria-expanded={activeDropdown === 'forms'}
              >
                Forms
              </a>
              <ul className={`dropdown-menu ${activeDropdown === 'forms' ? 'show' : ''}`}>
                <li>
                  <Link className="dropdown-item" to="/templates" onClick={handleLinkClick}>
                    Form Templates
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/create-form" onClick={handleLinkClick}>
                    Create Form
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/view-forms" onClick={handleLinkClick}>
                    View Forms
                  </Link>
                </li>
              </ul>
            </li>
            {/* Contracts Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={() => handleDropdown('contracts')}
                aria-expanded={activeDropdown === 'contracts'}
              >
                Contracts
              </a>
              <ul className={`dropdown-menu ${activeDropdown === 'contracts' ? 'show' : ''}`}>
                <li>
                  <Link className="dropdown-item" to="/contract-templates" onClick={handleLinkClick}>
                    Contract Templates
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/create-contract" onClick={handleLinkClick}>
                    Create Contract
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/view-contracts" onClick={handleLinkClick}>
                    View Contracts
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/clients" onClick={handleLinkClick}>
                Clients
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/venues" onClick={handleLinkClick}>
                Venues
              </Link>
            </li>
            {/* Register Link - Only for jkupis */}
            {isLoggedIn && username === 'jkupis' && (
              <li className="nav-item">
                <Link className="nav-link" to="/register" onClick={handleLinkClick}>
                  Register
                </Link>
              </li>
            )}
          </ul>
          <button
            onClick={handleAuthAction}
            className={`btn ${isLoggedIn ? 'btn-outline-danger' : 'btn-outline-primary'} ms-auto`}
          >
            {isLoggedIn ? 'Logout' : 'Log In'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;